import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import NotFound from "./pages/NotFound";
import Portfolio from "./pages/Portfolio";
import PortfolioAbout from "./pages/PortfolioAbout";
import PortfolioProjects from "./pages/PortfolioProjects";
import PortfolioExperience from "./pages/PortfolioExperience";
import PortfolioEducation from "./pages/PortfolioEducation";
import PortfolioContact from "./pages/PortfolioContact";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Cookbooks from "./pages/Cookbooks";
import CookbookDetail from "./pages/CookbookDetail";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "auto", block: "start" });
      };
      // Wait one frame for the target page to render, then scroll.
      requestAnimationFrame(() => {
        tryScroll();
        setTimeout(tryScroll, 80);
      });
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

const isPortfolioHost =
  typeof window !== "undefined" &&
  window.location.hostname.startsWith("portfolio.");

function App() {
  return (
    <BrowserRouter>
      <div className="bg-void min-h-screen font-terminal">
        <ScrollToTop />
        <Navbar />
        {isPortfolioHost ? (
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/about" element={<PortfolioAbout />} />
            <Route path="/projects" element={<PortfolioProjects />} />
            <Route path="/experience" element={<PortfolioExperience />} />
            <Route path="/education" element={<PortfolioEducation />} />
            <Route path="/contact" element={<PortfolioContact />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
            <Route path="/cookbooks" element={<Cookbooks />} />
            <Route path="/cookbooks/:slug" element={<CookbookDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogDetail />} />
            <Route path="/cookbooks" element={<Cookbooks />} />
            <Route path="/cookbooks/:slug" element={<CookbookDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        )}
        <Footer />
        <Toaster
          richColors
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              border: "2px solid #15803D",
              color: "#15803D",
              fontFamily: '"Space Mono", monospace',
              borderRadius: "0",
            },
          }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
